import React from 'react'

import { Accordion, AccordionItem, AccordionItemProps } from '../../../components/accordion/accordion.js'
import { PageTitle, PageTitleProps } from '../../../components/page-title/page-title.js'
import { Separator } from '../../../components/separator/separator.js'

export interface ViewFaqProps {
    title: PageTitleProps
    items: AccordionItemProps[]
}

export const ViewFaq = (props: ViewFaqProps): JSX.Element => {
    return (
        <>
            <PageTitle {...props.title} alwaysButton={true} />
            <Separator variant="large" />
            <Accordion variant="faq">
                {props.items.map((item: AccordionItemProps, index: number) => (
                    <AccordionItem {...item} key={index} />
                ))}
            </Accordion>
        </>
    )
}
